import { useGetNotificationsQuery } from '@/store/api/notificationApi';
import { cn } from '@/utils';
import React, { useState } from 'react';
import { FiMic } from 'react-icons/fi';
import LegalModal from './LegalModal';

interface PromoMarqueeProps {
  className?: string;
  iconClassName?: string;
}

export const PromoMarquee: React.FC<PromoMarqueeProps> = ({
  className = '',
  iconClassName = '',
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { data: notifications } = useGetNotificationsQuery(undefined);

  const { Alert } = notifications?.data ?? {};

  const alertNotifications = Alert?.map((n) => n?.body ?? '') || [
    ' WELCOME TO 9WINBET ! ENJOY BETTING IN MATCH ODDS, FANCY & LIVE CASINO ',
  ];

  const Content = () => (
    <div className="bg-white">
      {Array.isArray(Alert) ? (
        Alert.map((notification) => (
          <div key={notification.createdAt} className="space-y-4 pb-3 border-b border-gray-300">
            <span className="inline-flex rounded-full bg-[#222222] px-4 py-1 text-sm font-medium text-white">
              {new Date(notification.createdAt).toLocaleDateString('en-GB')}
            </span>

            <p className="whitespace-pre-wrap text-[1.1.075rem] text-[#494949] uppercase">
              {notification.body}
            </p>
          </div>
        ))
      ) : (
        <div className="space-y-4 pb-3 border-b border-gray-300">
          <span className="inline-flex rounded-full bg-[#222222] px-4 py-1 text-sm font-medium text-white">
            {new Date().toLocaleDateString('en-GB')}
          </span>

          <p className="whitespace-pre-wrap text-[1.075rem] text-[#494949] uppercase">
            WELCOME TO 9WINBET ! ENJOY BETTING IN MATCH ODDS, FANCY & LIVE CASINO
          </p>
        </div>
      )}
    </div>
  );

  return (
    <>
      <div
        onClick={() => setIsModalOpen(true)}
        className={cn(
          'animate-fade-in w-full h-[2.15rem] overflow-hidden flex items-center pr-5 bg-white',
          className
        )}
      >
        <div className="z-10 relative flex h-full w-14 shrink-0 items-center justify-center  bg-white">
          <span className="absolute w-[1px] top-1.5 bottom-1.5 right-0 bg-gray-300" />
          <FiMic className="text-[1.25rem] text-[#1f2937]" />
        </div>

        <div className="px-2.5 text-black text-[0.85rem] font-medium animate-marquee divide-x">
          {alertNotifications.map((notification, idx) => (
            <span key={idx} className="px-2">
              {notification}
            </span>
          ))}
        </div>
      </div>

      <LegalModal
        title={'Announcement'}
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        Content={Content}
      />
    </>
  );
};
